import { Entity, type EnemyConstruction } from "../Entity";

/** Proximity mine with charge, chase, impact, and timed detonation states. */
export class MineEntity extends Entity {
  private chaseOriginX = Number.NaN;
  private chaseOriginY = Number.NaN;

  constructor(init: EnemyConstruction) {
    super(init);
  }

  override get isMine(): boolean {
    return true;
  }

  protected override updateBehaviorAnimation(destroyed: number): number {
    if (this.rollData.slashState === 10) {
      destroyed = 4;
      this.rollData.slashState = 11;
    }
    if (this.rollData.slashState === 12) {
      destroyed = 5;
      this.rollData.slashState = 13;
    }
    if (this.rollData.slashState === 13 && this.rollData.counter >= 200) {
      this.dead = true;
    }
    return this.dead ? 2 : destroyed;
  }

  protected override onCollision(moveAllowed: readonly boolean[]): void {
    if (!moveAllowed[0] || !moveAllowed[1]) this.dead = true;
  }

  protected override updateSpecialChase(
    knightX: number,
    dist: number,
  ): boolean {
    if (dist < this.enemyData.playerDist) {
      this.rollData.slashState = 10;
      this.frame = 0;
      this.frameCounter = 0;
      this.animOffset = this.enemyData.animOffsetRoll;
      if (knightX > this.xPos) this.animOffset += 6;
      this.frameLimit = this.enemyData.frameLimitRoll;
    }
    return true;
  }

  protected override updateSpecialSlash(
    knightX: number,
    knightY: number,
    returnAction: number,
  ): number {
    if (this.rollData.slashState === 11 && this.slashData.counter >= 17) {
      this.slashData.counter = 0;
      this.rollData.slashState = 12;
    }
    if (this.rollData.slashState !== 13) return returnAction;
    if (Number.isNaN(this.chaseOriginX)) {
      this.chaseOriginX = this.xPos;
      this.chaseOriginY = this.yPos;
    }


    const mineSpeed = Math.min(this.slashData.counter * 0.25, 13);
    this.targetAngle =
      Math.atan2(knightY - this.yPos, knightX - this.xPos) * (180 / Math.PI);
    const radians = this.targetAngle * (Math.PI / 180);
    this.xSpeed = mineSpeed * Math.cos(radians);
    this.ySpeed = mineSpeed * Math.sin(radians);
    this.animOffset = this.enemyData.animOffsetRoll;
    if (knightX > this.xPos) this.animOffset += 6;
    if (this.xPos !== this.chaseOriginX || this.yPos !== this.chaseOriginY) {
      const dx = this.xPos - knightX;
      const dy = this.yPos - knightY;
      if (Math.sqrt(dx * dx + dy * dy) < 30) this.dead = true;
    }
    return returnAction;
  }
}
